import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './image.css';
var cx = classnames.bind(styles);
export default function Image(_ref) {
  var bordered = _ref.bordered,
      circular = _ref.circular,
      className = _ref.className,
      fluid = _ref.fluid,
      padded = _ref.padded,
      raised = _ref.raised,
      rounded = _ref.rounded,
      props = _objectWithoutProperties(_ref, ["bordered", "circular", "className", "fluid", "padded", "raised", "rounded"]);

  return (// Note: we disable eslint here because alt is a required prop of this component
    // eslint-disable-next-line jsx-a11y/alt-text
    React.createElement("img", _extends({
      className: cx('image', className, {
        raised: raised,
        bordered: bordered,
        padded: padded,
        circular: circular,
        rounded: !circular && rounded,
        fluid: fluid
      })
    }, props))
  );
}
Image.propTypes = {
  /** Text to identify image context */
  alt: PropTypes.string.isRequired,

  /** Boolean indicating if a border should be used */
  bordered: PropTypes.bool,

  /** Boolean indicating if the image should be a circle shape */
  circular: PropTypes.bool,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Boolean indicating to fill the width of the container */
  fluid: PropTypes.bool,

  /** Boolean indicating if there should be padding inside */
  padded: PropTypes.bool,

  /** Boolean to indicate if the image should have a box shadow */
  raised: PropTypes.bool,

  /** Boolean indicating if there should be rounded corners */
  rounded: PropTypes.bool
};
Image.defaultProps = {
  bordered: false,
  circular: false,
  className: undefined,
  padded: false,
  fluid: false,
  raised: false,
  rounded: false
};